import { render, staticRenderFns } from "./Dvorane.vue?vue&type=template&id=24edeab5&scoped=true&"
import script from "./Dvorane.vue?vue&type=script&lang=js&"
export * from "./Dvorane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24edeab5",
  null
  
)

export default component.exports